import { type Socket, io } from 'socket.io-client';

import { MissingChatSocketError } from './errors';

let socketInstance: null | Socket = null;

export const registerChatSocket = ({ url }: { url: string }) => {
  if (socketInstance) {
    socketInstance.removeAllListeners();
    socketInstance.disconnect();
  }

  socketInstance = io(url, {
    autoConnect: false,
    transports: ['websocket'],
  });
};

export const getSocket = (): Socket => {
  if (!socketInstance) {
    throw new MissingChatSocketError();
  }

  return socketInstance;
};
